export default __webpack_public_path__ + "static/media/pass.9b803ddf.png";